import EquipActionPortal from '../components/pages/EquipActionPortal/EquipActionPortal';
import Preferences from '../components/pages/Preferences';
import MoveOrderAdd from '../components/pages/MoveOrderAdd';
import Analytics from '../components/pages/Analytics';

/**
 * Router configuration for the application
 * @type {import('@pella/react-layout/dist/types').Route[]}
 */
export const routes = [
  {
    path: 'equip-action-portal',
    title: 'Equip Action Portal',
    icon: 'handyman',
    isPublic: false,
    element: <EquipActionPortal />,
    roles: ['ADMINISTRATOR', 'SUPER USER', 'USER'],
    hidden: false,
  },
  {
    path: 'move-order-add',
    title: 'Move Order',
    icon: 'order_approve',
    isPublic: false,
    element: <MoveOrderAdd />,
    roles: ['ADMINISTRATOR', 'SUPER USER', 'USER'],
    hidden: false,
  },
  {
    path: 'preferences',
    title: 'Preferences',
    icon: 'settings_heart',
    isPublic: false,
    element: <Preferences />,
    roles: ['ADMINISTRATOR', 'SUPER USER', 'USER'],
    hidden: false,
  },
  {
    path: 'analytics',
    title: 'Analytics',
    icon: 'query_stats',
    isPublic: false,
    element: <Analytics />,
    roles: ['ADMINISTRATOR', 'SUPER USER', 'USER'],
    hidden: false,
  },
];
